import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

interface INavMenuItem {
    link: string;
    label: string;
}

interface INavMenuProps {
    left: Array<INavMenuItem>;
    right: Array<INavMenuItem>;
}

export const NavMenu = ({ left, right } : INavMenuProps) => {

    const renderMenu = (sourceItems : Array<INavMenuItem>) => {
        let items : Array<JSX.Element> = [];
        if (sourceItems) {
            sourceItems.forEach(item => items.push(<Link to={item.link} className="nav-link">{item.label}</Link>));
        }
        return items;
    };


    return (
        <Navbar bg="whitespace" variant="dark" expand="lg">
            <Navbar.Toggle aria-controls="navbar"></Navbar.Toggle>
            <Navbar.Collapse id="navbar">
                <Nav className="me-auto">
                    {renderMenu(left)}
                </Nav>
                <Nav>
                    {renderMenu(right)}
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}
